import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { type ProjectCode } from '@constants'
import { cosignConfigMap } from '@cosign/constants/cosign-config'
import { Cosign } from '@cosign/Cosign'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom-v5'
import { AppBar } from '../../components/AppBar/AppBar'
import { LeftHeader } from '../../components/TheCampaignHeader'
import { clearToken } from '../../utils/clear-token'

export function CampaignLogin() {
  const history = useHistory()
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const project = exhibitorSettings?.brand_codes_info[0]?.project_code as Exclude<ProjectCode, 'FP' | 'HN' | 'ST'>
  const orderHashFromUrl = new URLSearchParams(window.location.search).get('orderHash')
  const { referrer } = (history.location.state as { referrer?: string | null } | undefined) || {}
  const campaignUrl = `${window.location.origin}/campaigns/${campaignCodeFromUrl}`
  const redirectUrl = referrer || (orderHashFromUrl ? `${campaignUrl}/thankyou/${orderHashFromUrl}?guidedLogin=success` : campaignUrl)
  const fallbackUrl = referrer || (orderHashFromUrl ? `${campaignUrl}/thankyou/${orderHashFromUrl}?guidedLogin=fail` : campaignUrl)
  const tokenLoginUrl = `${campaignUrl}/auth-processing`

  useEffect(() => {
    clearToken({ campaignCodeFromUrl })
  }, [campaignCodeFromUrl])

  if (!project) return null
  return (
    <>
      <AppBar left={<LeftHeader />} />
      <Cosign
        {...cosignConfigMap[project]}
        title="Buygather"
        environment="campaign"
        redirectUrl={redirectUrl}
        fallbackUrl={fallbackUrl}
        tokenLoginUrl={tokenLoginUrl}
        routeMap={{
          campaign: `/campaigns/${campaignCodeFromUrl}/login`,
          login: '/campaigns/:campaignID/login',
          passwordRegister: '/campaigns/:campaignID/password/register',
          passwordChange: '/campaigns/:campaignID/password/change',
          passwordReset: '/campaigns/:campaignID/password/reset',
          passwordSuccess: '/campaigns/:campaignID/password/success',
          bindPhone: '/campaigns/:campaignID/bind-phone',
          editAccount: '/campaigns/:campaignID/my-account/edit-account',
        }}
        campaignCode={campaignCodeFromUrl}
      />
    </>
  )
}
